import {
  SlButtonGroup
} from "./chunk.TQNKSYQE.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/button-group/button-group.ts
var BUTTON_CHILDREN = ["fadv-button", "fadv-radio-button"];
var FadvButtonGroup = class extends SlButtonGroup {
  constructor() {
    super(...arguments);
    this.pill = false;
    this.outline = false;
  }
  handleFocus(event) {
    const button = findButton(event.target);
    button == null ? void 0 : button.classList.add("sl-button-group__button--focus");
  }
  handleBlur(event) {
    const button = findButton(event.target);
    button == null ? void 0 : button.classList.remove("sl-button-group__button--focus");
  }
  handleMouseOver(event) {
    const button = findButton(event.target);
    button == null ? void 0 : button.classList.add("sl-button-group__button--hover");
  }
  handleMouseOut(event) {
    const button = findButton(event.target);
    button == null ? void 0 : button.classList.remove("sl-button-group__button--hover");
  }
  handleSlotChange() {
    const slottedElements = [...this.defaultSlot.assignedElements({ flatten: true })];
    slottedElements.forEach((el) => {
      var _a, _b;
      const index = slottedElements.indexOf(el);
      const button = findButton(el);
      if (button) {
        button.variant = (_a = this.variant) != null ? _a : button.variant;
        button.size = (_b = this.size) != null ? _b : button.size;
        button.pill = this.pill || button.pill;
        button.outline = this.outline || button.outline;
        button.classList.add("sl-button-group__button");
        button.classList.toggle("sl-button-group__button--first", index === 0);
        button.classList.toggle("sl-button-group__button--inner", index > 0 && index < slottedElements.length - 1);
        button.classList.toggle("sl-button-group__button--last", index === slottedElements.length - 1);
      }
    });
  }
};
__decorateClass([
  e({ reflect: true })
], FadvButtonGroup.prototype, "variant", 2);
__decorateClass([
  e({ reflect: true })
], FadvButtonGroup.prototype, "size", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvButtonGroup.prototype, "pill", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvButtonGroup.prototype, "outline", 2);
__decorateClass([
  watch("variant", { waitUntilFirstUpdate: true }),
  watch("size", { waitUntilFirstUpdate: true }),
  watch("pill", { waitUntilFirstUpdate: true }),
  watch("outline", { waitUntilFirstUpdate: true })
], FadvButtonGroup.prototype, "handleSlotChange", 1);
FadvButtonGroup = __decorateClass([
  n("fadv-button-group")
], FadvButtonGroup);
function findButton(el) {
  return BUTTON_CHILDREN.includes(el.tagName.toLowerCase()) ? el : el.querySelector(BUTTON_CHILDREN.join(","));
}

export {
  FadvButtonGroup
};
